var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoUser = function SvgIconNoUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 92,
    height: 92,
    rx: 46,
    fill: "#425267"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.59 28.09c-.78-.78-2.05-.78-2.83 0l-8.93 8.93c0-.09.01-.17.01-.26 0-5.1-4.15-9.26-9.26-9.26-5.11 0-9.26 4.15-9.26 9.26 0 5.11 4.15 9.26 9.26 9.26.09 0 .17-.01.26-.01l-3.07 3.07c-4.36.28-8.68 1.21-12.8 2.81-2.06.8-3.39 2.76-3.39 4.99v3.27c0 1.42.56 2.7 1.46 3.66l-3.47 3.47a2.004 2.004 0 0 0 1.41 3.42c.51 0 1.02-.2 1.41-.59l39.2-39.2c.78-.78.78-2.05 0-2.83v.01ZM61.202 51.88c-2.53-.99-5.13-1.72-7.77-2.21L37.602 65.5h21.64c2.96 0 5.36-2.4 5.36-5.36v-3.28c0-2.22-1.33-4.18-3.39-4.98h-.01Z",
    fill: "#9DACC0"
  })));
};
export default SvgIconNoUser;